import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import dashboard from './routes/dashboard'
import loginRoute from './routes/loginRoute'
import settingRoute from './routes/settingRoute'
import userRoute from './routes/userRoute'
import objective from './routes/objective'
import hierachic from './routes/hierachic'
import reportRoute from './routes/reportRoute'
import evaluation from './routes/evaluation'
import guide from './routes/guide'
import { setAuthToken } from '@/auth/auth' // Assurez-vous que l'importation est correcte
import { getJsonFromStorage } from "@/util/storageUtils"; // Importer la fonction pour récupérer les données du stockage
import historyRoute from './routes/historyRoute'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/profile'
    },
    {
      path: '/miscellaneous/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/miscellaneous/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    ...loginRoute,
    ...settingRoute,
    ...userRoute,
    ...dashboard,
    ...objective,
    ...historyRoute,
    ...evaluation,
    ...hierachic,
    ...reportRoute,
    ...guide,
    // ...dashboard, // Uncomment and use if you have a dashboard route
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  setAuthToken(token);

  const storedUserData = getJsonFromStorage('userData');
  const userRole = storedUserData ? storedUserData.role : 'User';

  const isLoggedIn = !!token;

  if (to.matched.some(route => route.meta.requiresAuth) && !isLoggedIn) {
    return next({ name: 'login' })
  }

  if (to.name === 'login' && isLoggedIn) {
    return next({ name: 'profile' })
  }

  if (
      to.matched.some(route => route.meta.requiresAdminOrHierarchy) &&
      !['Admin', 'Hierarchy'].includes(userRole)
  ) {
    return next({ name: 'profile' })
  }

  if (
      to.matched.some(route => route.meta.requiresAdminOrSuperAdmin) &&
      !['Admin', 'AdminSuper', 'Technician'].includes(userRole)
  ) {
    return next({ name: 'profile' })
  }


  if (to.matched.length === 0) {
    return next('/profile')
  }

  next()

});

export default router;
